import React, { lazy } from "react";

import { RoutedTabs, TabDefinition } from "fond/widgets/RoutedTabs";

import { SettingsTabContent } from "../common.styles";

const EditProfileFormTab = lazy(() => import("./EditProfileForm/EditProfileForm"));
const ChangePasswordTab = lazy(() => import("./ChangePasswordForm/ChangePasswordForm"));

const tabs: TabDefinition[] = [
  { label: "Details", path: "details", component: EditProfileFormTab, event: "settings.profile.details.viewed" },
  { label: "Change Password", path: "change-password", component: ChangePasswordTab, event: "settings.profile.change-password.viewed" },
];

const UserProfile: React.FC = () => {
  return <RoutedTabs ContentContainer={SettingsTabContent} prefix="/settings/profile" tabs={tabs} data-testid="user-profile" />;
};

export default UserProfile;
